import { FieldInput } from './FieldInput';
import { PricingPanel } from './PricingPanel';
import { PositioningBuilder } from './PositioningBuilder';
import { FinancialPanel } from './FinancialPanel';
import { TaskBoard } from './TaskBoard';

const PRICING_KEYS = ['price', 'cost_per_sale', 'markup_pct', 'expected_monthly_sales', 'monthly_fixed_expenses', 'monthly_income_goal'];
const progressOf = (tasks) => {
  const list = tasks || [];
  const weeks = {};
  [1, 2, 3, 4].forEach((w) => { const l = list.filter((t) => t.week === w); weeks[w] = { total: l.length, done: l.filter((t) => t.done).length }; });
  const done = list.filter((t) => t.done).length;
  return { total: list.length, done, pct: list.length ? Math.round((done / list.length) * 100) : 0, weeks };
};
const isNumericKey = (schema, k) => schema.sections.some((s) => s.fields.some((f) => f.key === k && ['money', 'number', 'percent'].includes(f.type)));

export const StageSections = ({ schema, stage, values, all, bp, autosave, missingKeys, personalize, onLinkAction }) => {
  const fieldErrors = autosave.status.fields || {};
  const useDraft = (text) => {
    if (values.positioning_statement?.trim() && !window.confirm('Replace your current positioning statement with a new draft from your answers?')) return;
    autosave.queue('positioning_statement', text);
  };
  return schema.sections.map((sec, i) => (
    <section key={sec.title} className="mt-12" data-testid={`stage-section-${i}`}>
      <h2 className="font-serif-display text-3xl text-matte">{personalize(sec.title)}</h2>
      {sec.intro && <p className="mt-2 text-sm text-matte/60">{personalize(sec.intro)}</p>}
      {sec.panel && (
        <div className="mt-3 inline-block text-[10px] uppercase tracking-[0.2em] text-matte/50 border border-matte/15 rounded-full px-3 py-1" data-testid="pricing-assumptions-label">Your assumptions</div>
      )}
      <div className="mt-4 rounded-2xl bg-white border border-matte/10 px-6 md:px-8">
        {sec.fields.map((f) => (f.type === 'tasks' ? (
          <TaskBoard key={f.key} value={values[f.key]} onChange={(v) => autosave.queue(f.key, v)} suggestions={bp.launch_suggestions}
            weeks={bp.weeks} progress={progressOf(values[f.key])} />
        ) : (
          <div key={f.key}>
            <FieldInput field={f} value={values[f.key]} personalize={personalize}
              onChange={(v) => autosave.queue(f.key, v)} onBlur={() => autosave.flush()}
              missing={missingKeys.has(f.key)} serverError={fieldErrors[f.key]}
              link={bp.links[`${stage}.${f.key}`]} onLinkAction={(a) => onLinkAction(f.key, a)} primary={all.discover?.business_model} />
            {f.key === 'positioning_statement' && <div className="-mt-3 pb-6"><PositioningBuilder answers={all} onUse={useDraft} /></div>}
          </div>
        )))}
      </div>
      {sec.takeaway && values[sec.fields[0].key] && (
        <p className="mt-4 border-l-2 border-gold pl-4 text-sm text-matte/75 leading-relaxed" data-testid={`takeaway-${sec.fields[0].key}`}>{personalize(sec.takeaway)}</p>
      )}
      {sec.panel === 'pricing' && <PricingPanel pricing={bp.pricing} updating={PRICING_KEYS.some((k) => k in autosave.dirty)} />}
      {sec.panel === 'financials' && <FinancialPanel financials={bp.financials} updating={Object.keys(autosave.dirty).some((k) => isNumericKey(schema, k))} />}
    </section>
  ));
};
